module.exports = __webpack_public_path__ + "img/services3.jpg?2efd930926b952c9ddce6a522bc16dd0";